const consoleLogger = require('./client-logger');

let defaultLogger = consoleLogger;

if (typeof window === 'undefined') {
  defaultLogger = require('./server-logger');
}

module.exports = defaultLogger;
